import {combineReducers} from 'redux'
import {all} from 'redux-saga/effects'
import AuthRedux from 'src/app/modules/auth/redux/AuthRedux'

export const rootReducer = () =>
  combineReducers({
    auth: AuthRedux.reducer(),
  })

export type RootState = ReturnType<ReturnType<typeof rootReducer>>

export function* rootSaga() {
  yield all([AuthRedux.saga()])
}
